import VueRouter from 'vue-router'
import Vue from 'vue'
Vue.use(VueRouter)
const home = () => import('@/view/home') // 首页
const basicInfo = () => import('@/view/basicInfo') // 基本信息
const representInfo = () => import('@/view/representInfo')
const representDetail = () => import('@/view/representInfo/representDetail')
const representInfoDetail = () => import('@/view/representInfo/representInfoDetail')
const peopleSystem = () => import('@/view/peopleSystem')
const peopleSystemDetail = () => import('@/view/peopleSystem/peopleSystemDetail')
const noticeList = () => import('@/view/noticeList')
const noticeListDetail = () => import('@/view/noticeList/noticeListDetail')
const policyRules = () => import('@/view/policyRules')
const policyRulesDetail = () => import('@/view/policyRules/policyRulesDetail')
const resumeStyle = () => import('@/view/resumeStyle')
const resumeStyleHome = () => import('@/view/resumeStyleHome')

const resumeStyleDetail = () => import('@/view/resumeStyle/resumeStyleDetail')
const lineMeeting = () => import('@/view/lineMeeting')
const lineMeetingDetail = () => import('@/view/lineMeeting/lineMeetingDetail')
const createMeeting = () => import('@/view/lineMeeting/createMeeting')
const workInfoDetail = () => import('@/view/basicInfo/workInfoDetail')
const test = () => import('@/view/test/index')


const township = () => import('@/view/township/index')
//const township = () => import('@/view/township/townshipStyleDetail')




const routes = [
	{
		path: '/',
		redirect: 'home'
	},
	{
		path: '/home',
		component: home
	},
	{
		path: '/basicInfo',
		component: basicInfo
	},
	{
		path: '/representInfo',
		component: representInfo
	},
	{
		path: '/representDetail',
		component: representDetail
	},
	{
		path: '/representInfoDetail',
		component: representInfoDetail
	},
	{
		path: '/peopleSystem',
		component: peopleSystem
	},
	{
		path: '/peopleSystemDetail',
		component: peopleSystemDetail,

	},
	{
		path: '/noticeList',
		component: noticeList,
	},
	{
		path: '/noticeListDetail',
		component: noticeListDetail,
	},
	{
		path: '/policyRules',
		component: policyRules,
	},
	{
		path: '/policyRulesDetail',
		component: policyRulesDetail,
	},
	{
		path: '/resumeStyle',
		component: resumeStyle,
	},
	{
		path: '/resumeStyleHome',
		component: resumeStyleHome,
	},
	{
		path: '/resumeStyleDetail',
		component: resumeStyleDetail,
	},
	{
		path: '/lineMeeting',
		component: lineMeeting,
	},
	{
		path: '/createMeeting',
		component: createMeeting,
	},
	{
		path: '/lineMeetingDetail',
		component: lineMeetingDetail,
	},
	{
		path: '/workInfoDetail',
		component: workInfoDetail,
	},
	{
		path: '/test',
		component: test,
	},{
		path: '/township',
		component: township, //乡镇地图

	},
	{
		path: '/TownshipDynamics',
		component:  ()=>import('@/view/TownshipDynamics/index'), //乡镇动态

	},
	{
		path: '/TownshipDynamicsDetail',
		component:  ()=>import('@/view/TownshipDynamics/TownshipDynamicsDetail'), //乡镇动态详情

	},
	{
		path: '/towDesc',
		component:  ()=>import('@/view/township/towDesc'), //新动态详情

	},
	{
		path: '/townshipStyleDetail',
		component:  ()=>import('@/view/township/townshipStyleDetail'), //动态详情

	},

	{
		path: '/fcList',
	//	component:  ()=>import('@/view/fcList/index'), //代表风采
		component:  ()=>import('@/view/fcList/index'), //代表风采

	},
	{
		path: '/fcListDetail',
		component:  ()=>import('@/view/fcList/fcListDetail'), //风采详情

	},
	{
		path: '/linkList',
		component:  ()=>import('@/view/linkList/index'), //代表学习

	},
	{
		path: '/linkDetail',
		component:  ()=>import('@/view/linkList/linkDetail'), //代表学习

	},
	{
		path: '/activityPlan',
		component:  ()=>import('@/view/activityPlan/index'), //活动计划

	},
	{         
		path: '/activityPlanDetail',
		component:  ()=>import('@/view/activityPlan/activityPlanDetail'), //活动计划详情

	},
	{
		path: '/community',
		component:  ()=>import('@/view/community/index'), //元槟社区

	},
	{         
		path: '/communityDetail',
		component:  ()=>import('@/view/community/communityDetail'), //元槟社区详情

	},
	{
		path: '/representActivity',
		component:  ()=>import('@/view/representActivity/index'), //代表之家活动

	},
	{         
		path: '/representActivityDetail',
		component:  ()=>import('@/view/representActivity/representActivityDetail'), //代表之家活动详情

	},
	{
		path: '/wenZhen',
		component:  ()=>import('@/view/wenZhen/index'), //群众回音

	},
	{         
		path: '/wenZhenDetail',
		component:  ()=>import('@/view/wenZhen/wenZhenDetail'), //群众回音详情

	},
	{         
		path: '/baseInfo',
		component:  ()=>import('@/view/baseInfo/index'), //基本信息

	},
	{         
		path: '/representList',
		component:  ()=>import('@/view/representList/index'), //代表信息

	}
	
]

const router = new VueRouter({
	routes
})

export default router
